<template>
    <div id="admin_panel" class="text-dark container-fluid">
        <nav class="navbar navbar-dark fixed-top shadow" style="height: 60px">
            <button
                ref="buttonCollapse"
                @click.stop="openMenu"
                class="hamburger border-0 position-relative" type="button" data-target="#sidebar" aria-controls="sidebar" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="hamburger-container position-relative" tabindex="-1">
                        <span class="hamburger-bars position-absolute"></span>
                    </span>
            </button>
            <a class="navbar-brand admin p-0" href="/">
                <h2 class="text-primary m-0 font-weight-bold">Strefa 3</h2>
            </a>
            <div class="dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Administrator
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="/">Strona główna</a>
                <a class="dropdown-item" href="https://sklep.strefatrzy.pl/">Sklep</a>
                <a class="dropdown-item" href="https://blog.strefatrzy.pl/wp-admin">Blog</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item danger" @click.prevent="$refs.logout.submit()" href="/logout">Wyloguj</a>

                <form id="logout-form" ref="logout" action="/logout" method="POST" class="d-none">
                    <input type="hidden" name="_token" :value="$props.csrf">
                </form>
            </div>
            </div>
        </nav>
        <div class="row min-vh-100">
            <div class="col-9 col-sm-6 col-md-4 col-lg-2 sidebar border-right bg-light px-0 pb-3" id="sidebar" ref="sidebar">
                <div class="sidebar-sticky pt-3">
                    <ul class="nav flex-column">
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home">
                                <iconHome />Dashboard
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/cards-tarot">
                                <iconCard />Karty tarota
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/cookies">
                                <iconText />Ciasteczka
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/numerology">
                                <iconStreet />Droga życia
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/about">
                                <iconPerson />O nas
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/contact">
                                <iconPhone />Kontakt
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/page/tarot">
                                <iconCard />Tarot
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/page/energy">
                                <iconEnergy />Energia
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/page/numerology">
                                <iconNumber />Numerologia
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/page/workshops">
                                <iconWorkshops />Warsztaty
                            </router-link>
                        </li>
                         <li class="nav-item">
                            <router-link class="nav-link d-flex align-items-center" to="/home/gallery">
                                <iconGallery />Galeria
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <main class="col-lg-10 ml-md-auto position-relative"
                :class="open ? 'brightness' : ''"
                @click="closeMenu()"
            >
                <div class="d-flex justify-content-center align-items-center loading" v-if="loading">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

                <transition name="component-fade" mode="out-in">
                    <div v-if="message.success || message.error" class="alert h5 shadow"
                        :class="message.success ? 'alert-success' : 'alert-danger'"
                        role="alert"
                    >
                    {{ closeMessage() }}
                        <span v-html="message.content"></span>
                        <button type="button" class="close ml-2"
                            @click="message.success = false; message.error = false"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </transition>

                <transition name="component-fade" mode="out-in">
                    <router-view />
                </transition>
            </main>
        </div>
    </div>
</template>

<script>
    import iconPerson from '../icon/PersonBadge';
    import iconHome from '../icon/home';
    import iconPhone from '../icon/telephone';
    import iconCard from '../icon/card';
    import iconNumber from '../icon/number';
    import iconText from '../icon/text';
    import iconGallery from '../icon/image';
    import iconEnergy from '../icon/energy';
    import iconWorkshops from '../icon/workshops';
    import iconStreet from '../icon/street';

    export default {
        props: ['csrf', 'api_token'],
        data(){
            return {
                loading: true,

                message: {
                    success: false,
                    error: false,
                    content: null,
                },
                open: false,
            }
        },
        components: {
            iconPerson, iconHome, iconPhone, iconCard, iconNumber, iconText, iconGallery, iconEnergy, iconWorkshops, iconStreet
        },
        watch: {
            'message.success'(el){
                let _this = this;
                if(el === true)
                {
                    setTimeout(function(){
                        _this.message.success = false;
                    }, 5000)
                }
            },
            'message.error'(el){
                let _this = this;
                if(el === true)
                {
                    setTimeout(function(){
                        _this.message.error = false;
                    }, 5000)
                }
            },
            '$route': function (el) {
                if($(this.$refs.buttonCollapse).hasClass('active'))
                {
                    this.openMenu();
                }
            }
        },
        methods: {
            openMenu(){
                let _this = this;
                let button = $(_this.$refs.buttonCollapse);
                let id = $(_this.$refs.buttonCollapse).data('target');

                $(_this.$refs.buttonCollapse).toggleClass('active');
                $(id).animate({width:'toggle'},350);

                this.open = !this.open;
            },
            closeMenu(){
                if($(this.$refs.buttonCollapse).hasClass('active'))
                {
                    this.openMenu();
                }
            },
            closeMessage(){
                // close message alert if watch not working
                if(this.message.success == true || this.message.error == true)
                {
                    let _this = this;
                    setTimeout(function(){
                        _this.message.success = false;
                        _this.message.error = false;
                    }, 5000)
                }

            }
        },
    }
</script>
